var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 220,
    viewBox: "0 0 416 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.71 125.517H301.53C301.53 125.517 312.75 94.8672 330.02 94.8672C347.29 94.8672 352.7 116.017 352.7 116.017C352.7 116.017 364.35 104.527 373.93 104.527C383.51 104.527 391.82 119.717 391.82 119.717C391.82 119.717 405.35 111.547 414.71 125.517Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.89 96.1495H1C1 96.1495 12.81 79.0195 22.13 79.0195C31.45 79.0195 34.19 90.4395 34.19 90.4395C34.19 90.4395 40.76 85.1095 46.85 86.0595C52.94 87.0095 53.89 96.1495 53.89 96.1495Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.38 40.2802H293.49C293.49 40.2802 305.31 23.1602 314.62 23.1602C323.93 23.1602 326.68 34.5802 326.68 34.5802C326.68 34.5802 333.26 29.2502 339.34 30.2002C345.42 31.1502 346.38 40.2802 346.38 40.2802Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.39 185.85H86.5C86.5 185.85 98.32 168.73 107.63 168.73C116.94 168.73 119.69 180.15 119.69 180.15C119.69 180.15 126.26 174.82 132.35 175.77C138.44 176.72 139.39 185.85 139.39 185.85Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.18 33.579H71.1802C71.1802 33.579 85.2902 2.07902 100.38 0.109024C115.47 -1.86098 122.7 23.519 122.7 23.519C122.7 23.519 132.43 14.519 140.08 14.519C147.73 14.519 153.62 26.379 153.62 26.379C153.62 26.379 168.89 18.269 174.18 33.579Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340.97 206.79H237.97C237.97 206.79 252.08 175.29 267.17 173.32C282.26 171.35 289.48 196.73 289.48 196.73C289.48 196.73 299.21 187.73 306.87 187.73C314.53 187.73 320.43 199.54 320.43 199.54C320.43 199.54 335.72 191.48 340.97 206.79Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212 193C251.765 193 284 160.765 284 121C284 81.2355 251.765 49 212 49C172.235 49 140 81.2355 140 121C140 160.765 172.235 193 212 193Z",
    fill: "#1B1D52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M212 193C251.765 193 284 160.765 284 121C284 81.2355 251.765 49 212 49C172.235 49 140 81.2355 140 121C140 160.765 172.235 193 212 193Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.83 160.621H164.72V178.601H168.83V160.621Z",
    fill: "#A6A6A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.14 178.598H166.78V185.028H168.14V178.598Z",
    fill: "#A6A6A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.67 186.059V184.699H164.24V186.059H170.67Z",
    fill: "#A6A6A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.61 187.578V183.168H164.25V187.578H165.61Z",
    fill: "#A6A6A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.67 187.59V183.18H169.31V187.59H170.67Z",
    fill: "#A6A6A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.16 179.871H161.87C161.274 179.871 160.79 180.355 160.79 180.951V189.821C160.79 190.418 161.274 190.901 161.87 190.901H163.16C163.757 190.901 164.24 190.418 164.24 189.821V180.951C164.24 180.355 163.757 179.871 163.16 179.871Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.04 179.871H171.75C171.153 179.871 170.67 180.355 170.67 180.951V189.821C170.67 190.418 171.153 190.901 171.75 190.901H173.04C173.636 190.901 174.12 190.418 174.12 189.821V180.951C174.12 180.355 173.636 179.871 173.04 179.871Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.35 161.194L168.055 176.93L168.624 177.338L179.919 161.602L179.35 161.194Z",
    fill: "#A6A6A6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.358 161.117L167.936 161.676L175.39 167.303L175.812 166.745L168.358 161.117Z",
    fill: "#A6A6A6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.25 157.629H142.54V164.189H147.25V157.629Z",
    fill: "#C7C7C7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M144.71 187.158C150.802 187.158 155.74 182.139 155.74 175.948C155.74 169.757 150.802 164.738 144.71 164.738C138.618 164.738 133.68 169.757 133.68 175.948C133.68 182.139 138.618 187.158 144.71 187.158Z",
    fill: "#C7C7C7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.263 181.899C156.641 177.522 156.641 170.424 152.263 166.046C147.886 161.668 140.788 161.668 136.41 166.046C132.032 170.424 132.032 177.522 136.41 181.899C140.788 186.277 147.886 186.277 152.263 181.899Z",
    fill: "#C7C7C7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.425 175.478C155.266 169.902 151.428 164.7 145.853 163.859C140.277 163.018 135.075 166.856 134.234 172.432C133.392 178.007 137.23 183.209 142.806 184.051C148.382 184.892 153.584 181.054 154.425 175.478Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4502 149.98H71.7402V156.54H76.4502V149.98Z",
    fill: "#C7C7C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8403 171.228C78.1536 171.228 81.6503 167.673 81.6503 163.288C81.6503 158.903 78.1536 155.348 73.8403 155.348C69.5269 155.348 66.0303 158.903 66.0303 163.288C66.0303 167.673 69.5269 171.228 73.8403 171.228Z",
    fill: "#C7C7C7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2984 163.728C82.3095 159.461 79.67 155.182 75.403 154.171C71.136 153.16 66.8573 155.8 65.8463 160.067C64.8352 164.334 67.4747 168.613 71.7417 169.624C76.0087 170.635 80.2874 167.995 81.2984 163.728Z",
    fill: "#C7C7C7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5703 169.12C77.5634 169.12 80.8003 165.883 80.8003 161.89C80.8003 157.897 77.5634 154.66 73.5703 154.66C69.5773 154.66 66.3403 157.897 66.3403 161.89C66.3403 165.883 69.5773 169.12 73.5703 169.12Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M191.07 154.08L8.61035 145V147.45L191.07 163.02V154.08Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.07 154.08V163.03L181.85 162.24L184.59 153.75L191.07 154.08Z",
    fill: "#C7C7C7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250.95 178.598H255.06V160.618H250.95V178.598Z",
    fill: "#A6A6A6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.64 185.027H253V178.597H251.64V185.027Z",
    fill: "#A6A6A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M255.53 186.059V184.699H249.1V186.059H255.53Z",
    fill: "#A6A6A6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M255.53 187.59V183.18H254.17V187.59H255.53Z",
    fill: "#A6A6A6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250.47 187.578V183.168H249.11V187.578H250.47Z",
    fill: "#A6A6A6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M257.9 179.871H256.61C256.014 179.871 255.53 180.355 255.53 180.951V189.821C255.53 190.418 256.014 190.901 256.61 190.901H257.9C258.497 190.901 258.98 190.418 258.98 189.821V180.951C258.98 180.355 258.497 179.871 257.9 179.871Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M248.02 179.871H246.73C246.133 179.871 245.65 180.355 245.65 180.951V189.821C245.65 190.418 246.133 190.901 246.73 190.901H248.02C248.616 190.901 249.1 190.418 249.1 189.821V180.951C249.1 180.355 248.616 179.871 248.02 179.871Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M240.431 161.213L239.862 161.621L251.157 177.357L251.726 176.949L240.431 161.213Z",
    fill: "#A6A6A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M251.432 161.134L243.978 166.762L244.399 167.32L251.854 161.693L251.432 161.134Z",
    fill: "#A6A6A6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M272.53 164.18H277.24V157.62H272.53V164.18Z",
    fill: "#C7C7C7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M275.07 187.158C281.162 187.158 286.1 182.139 286.1 175.948C286.1 169.757 281.162 164.738 275.07 164.738C268.978 164.738 264.04 169.757 264.04 175.948C264.04 182.139 268.978 187.158 275.07 187.158Z",
    fill: "#C7C7C7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M283.365 181.899C287.743 177.522 287.743 170.424 283.365 166.046C278.987 161.668 271.889 161.668 267.512 166.046C263.134 170.424 263.134 177.522 267.512 181.899C271.889 186.277 278.987 186.277 283.365 181.899Z",
    fill: "#C7C7C7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M277.253 184.023C282.801 183.017 286.484 177.704 285.479 172.156C284.474 166.607 279.161 162.924 273.612 163.93C268.064 164.935 264.381 170.248 265.386 175.796C266.392 181.345 271.704 185.028 277.253 184.023Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M343.32 156.539H348.03V149.979H343.32V156.539Z",
    fill: "#C7C7C7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M345.94 171.228C350.254 171.228 353.75 167.673 353.75 163.288C353.75 158.903 350.254 155.348 345.94 155.348C341.627 155.348 338.13 158.903 338.13 163.288C338.13 167.673 341.627 171.228 345.94 171.228Z",
    fill: "#C7C7C7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M348.047 169.61C352.314 168.599 354.953 164.32 353.942 160.053C352.931 155.786 348.652 153.147 344.385 154.158C340.118 155.169 337.479 159.447 338.49 163.714C339.501 167.981 343.78 170.621 348.047 169.61Z",
    fill: "#C7C7C7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M346.21 169.12C350.203 169.12 353.44 165.883 353.44 161.89C353.44 157.897 350.203 154.66 346.21 154.66C342.217 154.66 338.98 157.897 338.98 161.89C338.98 165.883 342.217 169.12 346.21 169.12Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M228.71 154.08L411.17 145V147.45L228.71 163.02V154.08Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M228.71 154.08V163.03L237.93 162.24L235.19 153.75L228.71 154.08Z",
    fill: "#C7C7C7"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M194 138.498L144.34 135.418V136.958L194 144.048V138.498Z",
    fill: "#EBEBEB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M194 138.5V144.05L186.35 142.95L187.12 138.07L194 138.5Z",
    fill: "#C7C7C7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M225.78 138.498L275.44 135.418V136.958L225.78 144.048V138.498Z",
    fill: "#EBEBEB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M225.77 138.5V144.05L233.43 142.95L232.66 138.07L225.77 138.5Z",
    fill: "#C7C7C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.36 149.301H194.22C190.741 149.301 187.92 152.121 187.92 155.601V166.911C187.92 170.39 190.741 173.211 194.22 173.211H199.36C202.839 173.211 205.66 170.39 205.66 166.911V155.601C205.66 152.121 202.839 149.301 199.36 149.301Z",
    fill: "#A6A6A6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M225.56 149.301H220.42C216.941 149.301 214.12 152.121 214.12 155.601V166.911C214.12 170.39 216.941 173.211 220.42 173.211H225.56C229.04 173.211 231.86 170.39 231.86 166.911V155.601C231.86 152.121 229.04 149.301 225.56 149.301Z",
    fill: "#A6A6A6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M211.26 170.359H208.53V182.279H211.26V170.359Z",
    fill: "#A6A6A6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M210.34 182.289H209.44V186.549H210.34V182.289Z",
    fill: "#A6A6A6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M212.02 187.228V186.328H207.76V187.228H212.02Z",
    fill: "#A6A6A6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M208.66 188.24V185.32H207.76V188.24H208.66Z",
    fill: "#A6A6A6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M212.02 188.24V185.32H211.12V188.24H212.02Z",
    fill: "#A6A6A6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M207.04 183.129H206.19C205.793 183.129 205.47 183.451 205.47 183.849V189.719C205.47 190.117 205.793 190.439 206.19 190.439H207.04C207.438 190.439 207.76 190.117 207.76 189.719V183.849C207.76 183.451 207.438 183.129 207.04 183.129Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M213.59 183.129H212.74C212.342 183.129 212.02 183.451 212.02 183.849V189.719C212.02 190.117 212.342 190.439 212.74 190.439H213.59C213.988 190.439 214.31 190.117 214.31 189.719V183.849C214.31 183.451 213.988 183.129 213.59 183.129Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M210.94 119.229H208.84L209.51 65.0391H210.26L210.94 119.229Z",
    fill: "#C7C7C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M209.89 171.039C196.52 171.039 187.27 162.869 188.35 145.039C189.35 128.039 199.97 119.039 209.89 119.039C219.81 119.039 230.4 128.119 231.43 145.039C232.51 162.869 223.25 171.039 209.89 171.039Z",
    fill: "#EBEBEB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M194.48 135.638L200.4 132.648L200.08 138.108L192.69 139.888L194.48 135.638Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M209.55 132.539V138.089L200.71 138.069L201.04 132.539H209.55Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M225.3 135.638L219.38 132.648L219.7 138.108L227.09 139.888L225.3 135.638Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M210.23 132.539V138.089L219.07 138.069L218.74 132.539H210.23Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M229.5 159.219C226.17 167.219 218.99 171.039 209.89 171.039C200.79 171.039 193.61 167.259 190.28 159.219C196.71 155.279 202.72 154.129 209.89 154.129C217.06 154.129 223.07 155.279 229.5 159.219Z",
    fill: "#1B1D52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightNotFound);
export default __webpack_public_path__ + "static/media/flight-not-found.009f8debb3e8ba305eb0f67f2b4a4f91.svg";
export { ForwardRef as ReactComponent };